import { CSSProperties } from 'react';
import { px2rem } from '../utils';
import { CommonProps, withNativeProps } from '../utils/native-props';
import { Column } from './column';
import './style.less';
import { PickerColumnItem, PickerColumnValue } from './types';
export * from './types';

const classPrefix = `v-picker`;

export type PickerProps = {
  pickerDataList: PickerColumnItem[];
  value?: PickerColumnValue;
  onChange?: (pickerColumnItem: PickerColumnItem) => void;
  itemHeight?: number;
} & CommonProps<{ '--height': CSSProperties['height'] }>;

export const Picker = (props: PickerProps) => {
  const pickerDataList = props.pickerDataList || [];
  const itemHeight = props.itemHeight || 100;

  return withNativeProps(
    { className: props.className, style: { ...props.style, '--item-height': px2rem(itemHeight) } },
    <div className={`${classPrefix}`}>
      <Column
        pickerDataList={pickerDataList}
        value={props.value}
        onChange={props.onChange}
        itemHeight={itemHeight}
      />
      <div className={`${classPrefix}-mask ${classPrefix}-mask-top`}>
        <div className={`${classPrefix}-mask-inner`}></div>
      </div>
      <div className={`${classPrefix}-mask ${classPrefix}-mask-bottom`}>
        <div className={`${classPrefix}-mask-inner`}></div>
      </div>
    </div>,
  );
};
